import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Markdown from "react-remarkable";

import Instructors from "../Instructors";
import { DATETIME, TIME } from "../../../utils/dateFormats";

const Attachments = ({ files }) => (files.map(file =>
  <div key={file.id} className="word-wrap">
    <a href={file.url} target="_blank" className="styled-link">
      {file.name}
    </a>
  </div>
));

const Information = ({ completed, inService, generalFiles, instructorsFiles }) => (
  <div className="well shadowDepth1 information">
    <h3 className="text-center">Information</h3>

    <div className="item hidden-xs">
      <label>Location</label>
      {inService.location ? inService.location.name : "No Location Specified"}
    </div>

    <div className="item hidden-xs">
      <label>Date</label>
      {moment(inService.start_time).format(DATETIME)}
      {" - "}
      {moment(inService.end_time).format(TIME)}
    </div>

    <div className="item">
      <label>Topic</label>
      {inService.topic}
    </div>

    <div className="item">
      <label>Categories</label>
      {_.map(inService.in_service_categories, 'name').join(', ')}
    </div>

    <div className="item hidden-xs">
      <label>Instructors</label>
      <Instructors users={inService.instructors}/>
    </div>

    {inService.notes ? (
      <div className="item">
        <label>Notes</label>
        <Markdown source={inService.notes} />
      </div>
    ) : null}

    {completed ? (
      <div className="item">
        <label>Status</label>
        Completed
      </div>
    ) : null}

    {generalFiles.length > 0 ? (
      <div className="item">
        <label>Attachments</label>
        <Attachments files={generalFiles}/>
      </div>
    ) : null}

    {instructorsFiles.length > 0 ? (
      <div className="item">
        <label>Instructors Attachments</label>
        <Attachments files={instructorsFiles}/>
      </div>
    ) : null}
  </div>
);

Information.propTypes = {
  completed: PropTypes.bool.isRequired,
  inService: PropTypes.object.isRequired,
  generalFiles: PropTypes.array.isRequired,
  instructorsFiles: PropTypes.array.isRequired
};

export default Information;
